import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import * as queries from '../../queries';

const AuctionNav = ({ auctionID }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedOption, setSelectedOption] = useState(location.pathname);
    const { loading: loadingAuction, data: dataAuction } = useQuery(queries.GET_AUCTIONBYID, {
        variables: { AuctionID: auctionID },
    });
    const auction = dataAuction?.oneAuctions;

    function formatDateTime(dateTimeString) {
        if (!dateTimeString) return '';
        const date = new Date(dateTimeString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    useEffect(() => {
        setSelectedOption(location.pathname);
    }, [location]);

    const handleChange = (value) => {
        setSelectedOption(value);
        navigate(value);
    };

    const tabs = [
        { label: 'Details', value: `/admin/AuctionInfos/${auctionID}/details` },
        { label: 'Lots', value: `/admin/AuctionInfos/${auctionID}/lots` },
        { label: 'Dashboard', value: `/admin/AuctionInfos/${auctionID}/dashboard` },
        { label: 'Check In', value: `/admin/AuctionInfos/${auctionID}/checkin` },
        { label: 'Settlement', value: `/admin/AuctionInfos/${auctionID}/settlement` }
    ];

    if (loadingAuction) return null;
    return (
        <>
            <div className="inventory-nav-container">
                <div className='dashboard-operation-part'>
                    <div className='a-tag-btn dashboard-main-btn'>
                        <div className='flex-row-direction align-center dashboard-main-btn-right'>
                            <a href={`/admin/auctions/current/${auction.AuctionID}/livelots`}>
                                <div className='currentAuction-name-location'>
                                    {auction.AuctionName}
                                    <address>
                                        {auction.LocationCode} --- {auction.UnitNum} {auction.Street} {auction.City} {auction.Province}
                                    </address>
                                </div>
                            </a>
                        </div>
                        <div className='flex-row-direction align-center dashboard-main-btn-left'>
                            <h4><span className='whitespace-nowrap'>{formatDateTime(auction.OpeningTime)}</span> - <span className='whitespace-nowrap'>{formatDateTime(auction.ClosedTime)}</span></h4>
                        </div>
                    </div>
                </div>
                <div className="tabs">
                    {tabs.map((tab) => (
                        <div
                            key={tab.value}
                            className={`tab ${selectedOption === tab.value ? 'active' : ''}`}
                            onClick={() => handleChange(tab.value)}
                        >
                            {tab.label}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default AuctionNav;